import styled, { css } from "styled-components";

export const RadioGroupContainer = styled.div`
  width: 100%;
  margin-bottom: 32px;
`;

export const RadioGroupTitle = styled.h2`
  font-size: 18px;
  font-weight: 500;
  color: #181d27;
  margin: 0 0 12px 0;
  font-family: "Geist", sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px; /* 150% */
`;

export const RadioOptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 13px;
`;

export const RadioOption = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 4px 16px;
  border-radius: 9999px;
  border: 1px solid #e9eaeb;
  background: #fafafa;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: border-color 0.2s ease, background-color 0.2s ease,
    color 0.2s ease;

  font-family: "Geist", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #414651;
  text-align: center;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
    `}
  &:hover {
    border-color: #2258f1;
    background: rgba(34, 88, 241, 0.05);
    color: #2258f1;
  }
  ${({ isSelected }) =>
    isSelected &&
    css`
      border-color: #2258f1;
      color: #2258f1;
      background: rgba(34, 88, 241, 0.08); /* subtle tint */
    `}
`;

export const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

// export const RadioCircle = styled.div`;
//   width: 20px;
//   height: 20px;
//   border: 2px solid ${({ isSelected }) => (isSelected ? "#3b82f6" : "#d1d5db")};
//   border-radius: 50%;
//   margin-right: 1rem;
//   position: relative;
//   transition: all 0.2s ease-in-out;
//   flex-shrink: 0;

//   ${({ isSelected }) =>
//     isSelected &&
//     css`
//       &::after {
//         content: "";
//         position: absolute;
//         top: 50%;
//         left: 50%;
//         transform: translate(-50%, -50%);
//         width: 8px;
//         height: 8px;
//         border-radius: 50%;
//         background-color: #3b82f6;
//       }
//     `}
// `;

export const RadioLabel = styled.label`
  font-size: 14px;
  cursor: pointer;
  flex: 1;
  color: ${({ isSelected }) => (isSelected ? "#2258f1" : "#414651")};
`;
